import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import 'mobx-react-lite/batchingForReactDom';
import NormalizeStyles from 'assets/NormalizeStyles';
import BaseStyles from 'assets/BaseStylesAlt';
import Toast from 'components/shared/Toast';
import Routes from './Routes';

const Container = () => (
  <>
    <NormalizeStyles />
    <BaseStyles />
    <Toast />
    <Routes />
  </>
);

ReactDOM.render(<Container />, document.getElementById('root'));
